import React, { Component } from "react";
import {
    Redirect
} from 'react-router-dom';
import { connect } from "react-redux";


class RequireAuth extends Component <{token: any}> {
    constructor(props) {
        super(props)
        this.state = {

        }
        console.log("Require auth check token : ",this.props.token)
    }
    
    render(){
        if (this.props.token) {
            return this.props.children;
        }
        return <Redirect to={'/Login'} />;
    }
};

const mapStateToProps = (state) => ({
    token: state.auth.currentUserToken,
});

export default connect(mapStateToProps, null)(RequireAuth);